module.exports = __webpack_public_path__ + "static/media/note-5_5.8dc3ac5b.png";